import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import msparcs from "assets/img/msparcs.png";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";

let menuList = [];

class WelcomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      chartHeight: "250px",
      web: true,
      mob: false,
      topmenus: false,
      totalemi: false,
      brandemi: false,
      unipay: false,
    };
  }
  componentWillMount() {
    menuList = JSON.parse(localStorage.getItem("MenuList"));
    if(menuList.includes("unipaynext"))
    {
      this.props.currentMenu("unipaynext");
    }
    // console.log("Name is:"+JSON.stringify(this.props.reducerState.menuList.length));
  }
  componentDidMount() {

    if (menuList.length == 1) {
      console.log("menuList length" + menuList);
      menuList.map((data, index) => {
        if (data.includes("totalemi")) {
          // this.props.currentMenu("totalemi");
          this.setState({ totalemi: !this.state.totalemi });

        }
        else if (data.includes("brandemi")) {
          this.setState({ brandemi: !this.state.brandemi });
        }
        else if (data.includes("unipaynext")) {
          this.setState({ unipay: !this.state.unipay });
        }
      })
    }

  }


  render() {
    if (menuList.length > 1) {
      console.log("menuList length: " + menuList);
      //this.props.history.push('/admin/welcomemenu');
      return <Redirect to="/admin/welcomemenu" />;
    }


    return (
      <>
        <div className="content-invoice">
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3"
                style={{ padding: "10px" }}
              >
                <div className="card p-10">
                  <div className="header text-center">
                    <h2 className="title">
                      <img
                        src={msparcs}
                        alt={msparcs}
                        className="mSpaceLogo"
                        width={"50%"}
                      />
                      <br />
                      Welcome To mSparcs
                    </h2>
                    <p className="category">
                      <strong> Innoviti’s Analytics Platform </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );

  }
}

const mapStateToProps = (state) => {
  return { reducerState: state }
}
const mapDispatchToProps = (dispatch) => {
  return {
    currentMenu: (name) => { dispatch({ type: 'change_menu', payload: name }) }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage);
